import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useForm } from "react-hook-form";
import { getCustomers } from "../../services/customerService";
import { getInventory, updateInventoryStock } from "../../services/inventoryService";
//import { getAllGuns, updateGun } from "../../services/gunService";
import { getProducts } from "../../services/productService";
import InvoicePreview from "./InvoicePreview";
import { placeOrder } from "../../services/orderService";
import "./OrderCreate.css";
import API from '../../services/api';

const InvoiceForm = ({ isOpen, onClose }) => {
    const { register, handleSubmit } = useForm();
    const [invoiceType, setInvoiceType] = useState("sales");
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [inventory, setInventory] = useState([]);
    //const [guns, setGuns] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [total, setTotal] = useState(0);
    const [error, setError] = useState("");
    const [discount, setDiscountState] = useState(0);
    const [products, setProducts] = useState([]);
    const [serialNumber,setSerialNumber] = useState("");
    const [notes, setNotes] = useState("");
    const [showInvoicePreview, setShowInvoicePreview] = useState(false);
    const [invoiceData, setInvoiceData] = useState({});
    const [salesRep, setSalesRep] = useState("");
    const [paymentMethod, setPaymentMethod] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);

    // Add these state variables
    const [salesRepresentatives, setSalesRepresentatives] = useState([]);
    const [userData, setUserData] = useState(null);

    let scannedCode = ""; // Temporary storage for scanned barcode
    let timeout; // Timeout for detecting end of scan

    // Fetch data when component mounts
    useEffect(() => {
        fetchCustomers();
        fetchInventory();
        //fetchGuns();
        fetchProducts();
        // loadSalesRepresentatives();
        fetchUserData();
    }, []);

    useEffect(() => {
        fetchUserData(); // Load user from localStorage
    }, []);

    // Add this useEffect to refresh data when modal opens/closes
    useEffect(() => {
        if (isOpen) {
            // Reset form state when opening
            setSelectedProducts([]);
            setSelectedCustomer(null);
            setNotes("");
            setSalesRep("");
            setPaymentMethod("");
            setDiscountState(0);
            setTotal(0);
            setSaveSuccess(false);
            setError("");

            // Fetch fresh data
            fetchCustomers();
            fetchInventory();
            //fetchGuns();
            fetchProducts();
        }
    }, [isOpen]);

    // Update total when selected products or discount changes
    useEffect(() => {
        calculateTotal();
    }, [selectedProducts, discount]);

    // barcode useEffect
    useEffect(() => {
        let scannedCode = "";
        let timeout;

        const handleKeyPress = async (event) => {
            if (event.key === "Enter") {
                event.preventDefault();
                if (scannedCode) {
                    fetchProduct(scannedCode);
                    scannedCode = ""; // Reset barcode after scanning
                }
            } else {
                scannedCode += event.key;
                clearTimeout(timeout);

                timeout = setTimeout(() => {
                    scannedCode = ""; // Reset if no input after 100ms
                }, 100);
            }
        };

        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, []);

    // Fetch product details by barcode
    const fetchProduct = async (barcode) => {
        try {
            const response = await API.get(`/products/barcode/${barcode}`);
            const product = response.data;

            if (!product) {
                alert("Product not found!");
                return;
            }

            addToSelectedProducts(product);
        } catch (error) {
            console.error("Error fetching product:", error);
        }
    };

    // Add product to selected items table with stock check
    const addToSelectedProducts = (product) => {
        setError("");
        setSelectedProducts((prevProducts) => {
            const existingProduct = prevProducts.find((item) => item.id === product.id);

            if (existingProduct) {
                if (existingProduct.quantity + 1 > product.stock) {
                    setError(`Stock limit exceeded for ${product.product_name}`);
                    return prevProducts; // Prevent adding if stock limit is exceeded
                }
                return prevProducts.map((item) =>
                    item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
                );
            } else {
                return [...prevProducts, { ...product, quantity: 1 }];
            }
        });
    };
    // 1. Updated fetchUserData function
    const fetchUserData = () => {
        try {
            const userStr = localStorage.getItem("user");
            if (userStr) {
                const parsedUser = JSON.parse(userStr);
                if (parsedUser.firstName && parsedUser.lastName) {
                    const fullName = `${parsedUser.firstName} ${parsedUser.lastName}`;
                    const userRole = parsedUser.role || "Staff";
                    // Set user data state
                    setUserData(parsedUser);
                    console.log(parsedUser)
                    // Set sales rep value
                    setSalesRep(fullName);

                    // Set the sales rep option directly
                    setSalesRepresentatives([{
                        label: `${fullName} - ${userRole}`,
                        value: fullName
                    }]);
                } else {
                    console.warn("User data incomplete in localStorage");
                }
            } else {
                console.warn("No user data found in localStorage");
            }
        } catch (error) {
            console.error("Error retrieving user data:", error);
        }
    };
    const loadSalesRepresentatives = () => {
        // This would typically come from an API, but for now we'll use hardcoded values
        // plus the current user from localStorage
        const reps = [
        ];

        // Add current user if available and not already in the list
        if (userData && userData.firstName && userData.lastName) {
            const fullName = `${userData.firstName} ${userData.lastName}`;
            const userRole = userData.role || "Staff";

            if (!reps.some(rep => rep.value === fullName)) {
                reps.push({
                    label: `${fullName} - ${userRole}`,
                    value: fullName
                });
            }
        }

        setSalesRepresentatives(reps);
    };

    const handleError = (err) => {
        console.error(err);
    };

    const onSubmit = async (data) => {
        // Validation Checks
        if (!selectedCustomer) {
            setError("Please select a customer before proceeding.");
            return;
        }

        if (!paymentMethod) {
            setPaymentMethod("Cash"); // Default to Cash if not selected
        }

        if (selectedProducts.length === 0) {
            setError("Please add at least one product before submitting.");
            return;
        }

        const generateInvoiceNo = () => {
            const now = new Date();
            const formattedDate = now.toISOString().replace(/[-T:Z.]/g, "").slice(2, 12)+now.getSeconds(); 
            return `WTS${formattedDate}`;
        };
        
        //console.log(generateInvoiceNo());        
        
        // Generate a unique invoice number
        const invoiceNo = generateInvoiceNo();
        const currentDate = new Date().toISOString().split("T")[0];

        try {
            // Prepare Invoice Data for Preview
            // Updated part of the onSubmit function to fix salesRepresentative
            const invoiceDetails = {
                invoiceNo: invoiceNo,
                date: currentDate,
                customerNIC: selectedCustomer.value,
                customerName: selectedCustomer.label,
                customerAddress: selectedCustomer.address || "No Address Provided",
                customerPhone: selectedCustomer.phone || "No Phone Provided",
                // Fix: Use the salesRep string instead of the salesRepresentatives array
                salesRepresentative: salesRep || "Not Specified",
                paymentMethod: paymentMethod || "Cash",
                serialNumber: serialNumber || "Serial Number Not Provided",
                notes: notes || "No additional notes",
                items: selectedProducts.map(p => ({
                    name: p.product_name,
                    quantity: p.quantity,
                    unitPrice: p.price,
                    totalPrice: (p.price * p.quantity).toFixed(2)
                })),
                total: parseFloat(total) + parseFloat(discount),
                discount: parseFloat(discount),
                grandTotal: parseFloat(total).toFixed(2),
            };

            // Show Invoice Preview
            setInvoiceData(invoiceDetails);
            setShowInvoicePreview(true);
            setError(""); // Clear any errors
        } catch (error) {
            console.error("Error preparing invoice:", error);
            setError("Failed to prepare the invoice. Please try again.");
        }
    };

    // Handle final submission to save to database
    const handleSaveInvoice = async () => {
        if (isSubmitting) return; // Prevent multiple submissions

        setIsSubmitting(true);
        setError("");

        try {
            // Prepare order data for API
            const orderData = {
                invoice: {
                    invoiceNumber: invoiceData.invoiceNo,
                    customerId: selectedCustomer.value, // NIC from customer
                    invoiceDate: invoiceData.date,
                    totalAmount: invoiceData.total,
                    discount: invoiceData.discount,
                    finalAmount: invoiceData.grandTotal,
                    paymentMethod: invoiceData.paymentMethod,
                    salesRepresentative: invoiceData.salesRepresentative,
                    paymentStatus: "Pending",
                    invoiceType: invoiceType,
                    serialNumber: invoiceData.serialNumber,
                    notes: invoiceData.notes
                },
                items: selectedProducts.map(p => {
                    return {
                        productId: p.id, // This should now be the correct product ID from the products table
                        productName: p.product_name,
                        categoryName: p.category_name,
                        //serialNumber: p.category_name === "Gun" ? p.serial_number : null,
                        quantity: p.quantity,
                        unitPrice: p.price,
                        totalPrice: p.price * p.quantity
                    };
                })
            };

            // Log the final data being sent to API for debugging
            console.log("Sending order data:", JSON.stringify(orderData));

            // Save to database
            const result = await placeOrder(orderData);

            // Update Gun Status and Inventory Quantities
            const updatePromises = selectedProducts.map(async (product) => {
                // For accessories, update inventory quantity
                const newQuantity = product.stock - product.quantity;
                console.log(`Updating inventory for ${product.product_name} (ID: ${product.inventory_id}), new quantity: ${newQuantity}`);

                try {
                    await updateInventoryStock(product.product_id, newQuantity);
                    console.log(`Inventory quantity updated successfully`);
                } catch (error) {
                    console.error(`Failed to update inventory quantity:`, error);
                    // Don't fail the entire process if inventory update fails
                }
            });

            // Wait for all updates to complete
            await Promise.all(updatePromises);

            // Show success message
            setSaveSuccess(true);

            // Immediately clear form data
            setSelectedProducts([]);
            setError("");

            // Refresh available products data
            //fetchGuns();
            fetchInventory();

            // Reset form after 2 seconds
            setTimeout(() => {
                setShowInvoicePreview(false);
                setSelectedCustomer(null);
                setNotes("");
                setSalesRep("");
                setPaymentMethod("");
                setDiscountState(0);
                setTotal(0);
                setSaveSuccess(false);
                onClose(); // Close the modal
            }, 2000);

        } catch (error) {
            console.error("Error saving invoice:", error);
            setError("Failed to save the invoice to the database. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await getProducts();

            if (!Array.isArray(response)) {
                console.error("Invalid product data format:", response);
                setProducts([]);
                return;
            }

            setProducts(response);
        } catch (error) {
            console.error("Error fetching product prices:", error);
            setProducts([]);
        }
    };

    const fetchCustomers = async () => {
        try {
            const response = await getCustomers();

            const formattedCustomers = response.map((customer) => ({
                label: `${customer.FirstName} ${customer.LastName}`,
                value: customer.NIC,
                phone: customer.ContactNumber || "No Phone Provided",  // ✅ Include Phone
                address: customer.Address || "No Address Provided"
            }));
            setCustomers(formattedCustomers);
        } catch (error) {
            console.error("Error fetching customers:", error);
            setCustomers([]);
        }
    };

    const setDiscount = (value) => {
        const discountValue = parseFloat(value) || 0;
        if (discountValue < 0) {
            setError("Discount cannot be negative");
            return;
        }

        setError("");
        setDiscountState(discountValue);
        calculateTotal();
    };

    const fetchInventory = async () => {
        try {
            const response = await getInventory();
            if (Array.isArray(response.data)) {
                setInventory(response.data);
            } else {
                setInventory([]);
                console.error("Unexpected inventory data format:", response);
            }
        } catch (error) {
            console.error("Error fetching inventory:", error);
            setInventory([]);
        }
    };

    const addProduct = (selectedOption) => {
        let productList = inventory; // Only dealing with accessories now

        if (!Array.isArray(productList)) {
            console.error("Invalid product list:", productList);
            return;
        }

        const product = productList.find((p) => p.id === selectedOption.value);
        if (!product) {
            console.error(`Product not found in inventory list:`, selectedOption);
            return;
        }

        // Find the actual product from the products table
        let actualProductId;
        let productWithPrice;

        if (product.product_id) {
            actualProductId = product.product_id;
            productWithPrice = products.find(p => p.id === actualProductId);
            console.log(`Found accessory by product_id: ${actualProductId}`, productWithPrice);
        } else {
            // Try to find by ID directly
            productWithPrice = products.find(p => p.id === product.id);
            if (productWithPrice) {
                actualProductId = productWithPrice.id;
                console.log(`Found accessory by direct id match: ${product.id}`, productWithPrice);
            }
        }

        // Final check for product
        if (!productWithPrice) {
            console.error(`Product not found: ${product.product_name}`);
            setError(`Price not found for ${product.product_name}`);
            return;
        }

        const productPrice = parseFloat(productWithPrice.price) || 0;

        // Check if accessory is already in cart
        const existingAccessory = selectedProducts.find(p =>
            p.product_id === actualProductId
        );

        if (existingAccessory) {
            // Check if we can add more
            if (existingAccessory.quantity + 1 > product.quantity) {
                setError(`Stock limit exceeded for ${product.product_name}`);
                return;
            }

            // Update quantity
            setSelectedProducts(prev => prev.map(item =>
                item === existingAccessory
                    ? { ...item, quantity: item.quantity + 1 }
                    : item
            ));
        } else {
            // Add new accessory
            if (product.quantity < 1) {
                setError(`No stock available for ${product.product_name}`);
                return;
            }

            setSelectedProducts(prev => [
                ...prev,
                {
                    id: actualProductId,                   // Product table ID for form rendering
                    product_id: actualProductId,           // Store reference to product table
                    inventory_id: product.id,              // Store original inventory ID for stock update
                    quantity: 1,
                    price: productPrice,
                    product_name: productWithPrice.name,   // Use product table name
                    category_name: "Accessory",
                    stock: product.quantity               // Available stock
                }
            ]);
        }

        // Clear errors and update total
        setError("");
        calculateTotal();
    };

    const updateQuantity = (id, newQuantity) => {
        setSelectedProducts(prevProducts =>
            prevProducts.map(product => {
                if (product.id === id) {
                    // Ensure quantity does not exceed available stock
                    if (newQuantity > product.stock) {
                        setError(`Stock limit exceeded for ${product.product_name}`);
                        return { ...product, quantity: product.stock };
                    }

                    return { ...product, quantity: Math.max(1, newQuantity) };
                }
                return product;
            })
        );

        setError("");
        calculateTotal();
    };

    const removeProduct = (productId) => {
        setSelectedProducts(selectedProducts.filter((item) => item.id !== productId));
        setError("");
        calculateTotal();
    };

    const calculateTotal = () => {
        const subtotal = selectedProducts.reduce((acc, item) => acc + item.price * item.quantity, 0);

        // Apply discount
        let finalTotal = subtotal - discount;
        if (finalTotal < 0) finalTotal = 0; // Prevent negative total

        setTotal(finalTotal.toFixed(2));
    };

    const handleDiscountChange = (value) => {
        const discountValue = parseFloat(value) || 0;

        if (discountValue < 0) {
            setError("Discount cannot be negative");
            return;
        }

        setError("");
        setDiscountState(discountValue);
    };

    // Handle closing invoice preview
    const handleClosePreview = () => {
        setShowInvoicePreview(false);
    };

    // Handle going back from invoice preview
    const handleBackFromPreview = () => {
        setShowInvoicePreview(false);
    };

    if (!isOpen) return null;
    // console.log(salesRepresentatives);
    return (
        <div>
            {showInvoicePreview ? (
                // ✅ Invoice Preview
                <InvoicePreview
                    invoiceData={invoiceData}
                    error={error}
                    saveSuccess={saveSuccess}
                    isSubmitting={isSubmitting}
                    onClose={handleClosePreview}
                    onBack={handleBackFromPreview}
                    onSave={handleSaveInvoice}

                />
            ) : (
                // ✅ Main Invoice Form
                <div className="invoice-modal-overlay" onClick={onClose}>
                    <div className="invoice-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="invoice-close-btn" onClick={onClose}>×</button>
                        <h2 className="invoice-title">Create Invoice</h2>
                        {/* Invoice Type & Sales Representative */}
                        <div className="invoice-form-row">
                            <div className="invoice-form-group">
                                <label>Sales Type</label>
                                <Select
                                    options={[
                                        { label: "Sales", value: "sales" },
                                        { label: "Credit", value: "credit" }
                                    ]}
                                    onChange={(e) => setInvoiceType(e.value)}
                                    defaultValue={{ label: "Sales", value: "sales" }}
                                />
                            </div>

                            <div className="invoice-form-group">
                                <label className="ic-label">Sales Representative</label>
                                <Select
                                    options={salesRepresentatives}
                                    value={salesRepresentatives.length > 0 ? salesRepresentatives[0] : null}
                                    isDisabled={true}
                                    className="invoice-select"
                                    placeholder="Loading user information..."
                                />
                            </div>
                        </div>
                        {/* Customer & Payment Method */}
                        <div className="invoice-form-row">
                            <div className="invoice-form-group">
                                <label>Customer</label>
                                <Select
                                    options={customers}
                                    placeholder="Select a Customer"
                                    onChange={(e) => {
                                        setSelectedCustomer(e);
                                    }}
                                />
                            </div>

                            <div className="invoice-form-group">
                                <label>Payment Method</label>
                                <Select
                                    options={[
                                        { label: "Cash", value: "Cash" },
                                        { label: "Card", value: "Card" },
                                        { label: "Bank Transfer", value: "Bank Transfer" },
                                        { label: "Cheque", value: "cheque" }
                                    ]}
                                    onChange={(e) => setPaymentMethod(e.value)} // Capture payment method
                                    placeholder="Select Payment Method"
                                    defaultValue={{ label: "Cash", value: "Cash" }}
                                />
                            </div>
                        </div>

                        {/* Weapon & Accessories Section */}
                        <div className="invoice-form-row">
                            {/* <div className="invoice-form-group">
                                <label>Weapon</label>
                                <Select
                                    options={guns.map((g) => ({
                                        label: `${g.product_name} - ${g.serial_number}`,
                                        value: g.id
                                    }))}
                                    onChange={(e) => addProduct(e, "guns")}
                                    placeholder="Select a weapon"
                                />
                            </div> */}

                            <div className="invoice-form-group">
                                <label>Select Product</label>
                                <Select
                                    options={inventory.map((p) => ({
                                        label: `${p.product_name} (Stock: ${p.quantity})`,
                                        value: p.id,
                                        stock: p.quantity
                                    }))}
                                    onChange={(e) => addProduct(e)}
                                    placeholder="Select an item"
                                />
                            </div>
                        </div>

                        {/* Selected Products Table */}
                        <div className="invoice-selected-items">
                            <h6>Selected Items</h6>
                            {selectedProducts.length === 0 ? (
                                <p>No products added</p>
                            ) : (
                                <table className="invoice-table">
                                    <thead>
                                        <tr>
                                            <th>Product Name</th>
                                            <th>Stock</th>
                                            <th>Unit Price</th>
                                            <th>Quantity</th>
                                            <th>Total Price</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {selectedProducts.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.product_name}</td>
                                                <td>{item.stock}</td>
                                                <td>Rs.{(Number(item.price) || 0).toFixed(2)}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        min="1"
                                                        max={item.stock}
                                                        value={item.quantity}
                                                        onChange={(e) => {
                                                            const newValue = parseInt(e.target.value) || 1;
                                                            updateQuantity(item.id, newValue);
                                                        }}
                                                        className="invoice-quantity-input"
                                                    />
                                                </td>
                                                <td>Rs.{(Number(item.price) * item.quantity || 0).toFixed(2)}</td>
                                                <td>
                                                    <button className="invoice-remove-btn" onClick={() => removeProduct(item.id)}>
                                                        X
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Discount and Total Amount Section */}
                        <div className="invoice-form-row">
                            <div className="invoice-form-group">
                                <label>Discount (Rs.)</label>
                                <input
                                    type="number"
                                    min="0"
                                    value={discount}
                                    onChange={(e) => handleDiscountChange(e.target.value)}
                                    className="invoice-discount-input"
                                    placeholder="Enter discount"
                                />

                            </div>
                        </div>

                        <div className="invoice-total-band">
                            <span className="invoice-total-label">Total:</span>
                            <span className="invoice-total-value">Rs.{total}</span>
                        </div>
                        <div className="invoice-form-group">
                            <label>Serial Number</label>
                            <textarea
                                className="invoice-notes-input"
                                placeholder="Enter Serial Number or Numbers..."
                                value={serialNumber}
                                onChange={(e) => setSerialNumber(e.target.value)}
                            />
                        </div>

                        {/* Notes Section */}
                        <div className="invoice-form-group">
                            <label>Notes</label>
                            <textarea
                                className="invoice-notes-input"
                                placeholder="Enter additional notes..."
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            />
                        </div>
                        {error && <p className="invoice-error-message">{error}</p>}
                        {/* Submit Button */}
                        <button onClick={handleSubmit(onSubmit)} className="invoice-save-btn">
                            Preview Invoice
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InvoiceForm;